import Home from '@/screens/relatorios_ouvidoria/Home'
import RelatoriosOuvidoria from '@/screens/relatorios_ouvidoria/RelatoriosOuvidoria'
import ListagemConversas from '@/screens/relatorios_ouvidoria/ListagemConversas'

const setRouteGroup = group => {
  return { routeGroup: group }
}

const relatoriosOuvidoria = [
  {
    path: 'ouvidoria/home',
    component: Home,
    children: [
      {
        path: '/ouvidoria/relatorios',
        name: 'ouvidoriaRelatorios',
        component: RelatoriosOuvidoria,
        meta: {
          ...setRouteGroup('OUVIDORIA_RELATORIOS')
        }
      },
      {
        path: '/ouvidoria/conversas',
        name: 'ouvidoriaConversas',
        component: ListagemConversas,
        meta: {
          ...setRouteGroup('OUVIDORIA_CONVERSAS')
        }
      }
    ]
  }
]

export default relatoriosOuvidoria



// WEBPACK FOOTER //
// ./src/router/relatorios_ouvidoria.js